import { Collapse } from '@blueprintjs/core';
import styled from 'styled-components';

const TRANSITION_DURATION = 550;

// Keep Blueprint's lifecycle timer in sync with both animated elements.
const GoalCollapse = styled(Collapse).attrs({
  transitionDuration: TRANSITION_DURATION,
})`
  && {
    transition: height ${TRANSITION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  && > .bp3-collapse-body {
    transition: transform ${TRANSITION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  @media (prefers-reduced-motion: reduce) {
    &&,
    && > .bp3-collapse-body {
      transition: none;
    }
  }
`;

export default GoalCollapse;
